import { useEffect, useRef, useState } from "react";
import { Button, ButtonGroup, ButtonToolbar, Table, Tooltip, Whisper } from "rsuite";
import { formatNumber } from "../../utils/formatter";

const { Column, Cell, HeaderCell } = Table;

// Alert table Custom Cell
const CustomCell = ({ rowData, dataKey, ...props }: any) => {
    const textareaRef = useRef<any>();
    const [isFocused, setIsFocused] = useState(false);
    const [changeData, setChangeData] = useState<{}>();
    const [adjustedForecast0, setAdjustedForecast0] = useState<number>(rowData["AdjustedForecast0"]);
    const [adjustedForecast1, setAdjustedForecast1] = useState<number>(rowData["AdjustedForecast1"]);
    const [Comments, setComments] = useState<string>(rowData["Comments"]);
    const handleReviewClick = (data: any) => {
        props.handleReviewChange([{
            SKUl: data?.SKUl,
            reviewedFlag: data?.check,
            Comments: data?.Comments
        }])
    }
    const handleForecastChange = (data: any) => {
        let obj = {
            SKUl: data?.SKUl,
            adjustedForecast: parseInt(data?.newValue),
            type: data?.type,
            Forecast0: parseInt(data?.Forecast0),
            Forecast1: parseInt(data?.Forecast1),
            prevForecast0: parseInt(data?.prevForecast0),
            prevForecast1: parseInt(data?.prevForecast1),
            Comments: data?.Comments,
        };

        // props.foreCastingChange(obj);
        if(data?.type == 0){
            setAdjustedForecast0(data?.newValue);
        }
        else if(data?.type == 1){
            setAdjustedForecast1(data?.newValue);
        }
        else if(data?.type == 2){
            setComments(data?.Comments);
        }
        setChangeData(obj);
    };
    const handleRowSelection=(data:any)=>{
        props?.handleRowSelection({
            SKUl:data?.SKUl,
            plant:data?.PLANT_PLANT,
            material:data?.MATERIAL_MATERIAL
        })
    }

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };

    useEffect(() => {
        if (changeData) {
            props.foreCastingChange(changeData)
        }
    }, [changeData]);

    useEffect(() => {
        if (textareaRef.current) {
          textareaRef.current.focus();
        }
    }, [Comments]);

    let keyWords = [
        "forecast_date",
        "AdjustedForecast1",
        "AdjustedForecast0",
        "CurrentMonthDemandLY",
        "forecastMonth1",
        "forecastMonth0",
        "standard_price",
        "annualRevenue",
        "AvgDemand_Last12Months",
        "AvgDemand_Last8Months",
        "AvgDemand_Last4Months",
        "AvgForecast_Last4Months",
        "Last4Month_Accuracy",
        "Lag1_Foreast",
        "Lag2_Foreast",
        "Comments",
        "isReviewed",
        "Alerts",
        "CurrentMonthOpenSalesQty",
        "MATERIAL_MATERIAL"
    ];

    return <Cell {...props} onClick={(e)=>{
        if((e.target instanceof HTMLInputElement)){
            return;
        }
        handleRowSelection(rowData)
    }}>
        {!keyWords.includes(dataKey) && (
            <p className="table-cell-title font-normal table-cell-title font-normal ">{rowData[dataKey]}</p>
        )}
        {dataKey === "MATERIAL_MATERIAL" &&
            <p className="table-cell-title font-normal table-cell-title font-normal flex items-start gap-2">
                <span>{rowData[dataKey]}</span>
                {(rowData?.Alerts?.includes('HighOverForecasting') ||
                    rowData?.Alerts?.includes('HighUnderForecasting')) &&
                    <span onClick={(e) => {
                        e.stopPropagation();
                        props.setopenmodal(rowData?.SKUl);
                    }}
                        className="mt-[2px] cursor-pointer">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6 12.5C9.31371 12.5 12 9.81371 12 6.5C12 3.18629 9.31371 0.5 6 0.5C2.68629 0.5 0 3.18629 0 6.5C0 9.81371 2.68629 12.5 6 12.5ZM6 2.90234C5.45964 2.90234 5.18945 3.14486 5.18945 3.62988C5.18945 4.11816 5.45964 4.3623 6 4.3623C6.27018 4.3623 6.47201 4.29883 6.60547 4.17188C6.74219 4.04167 6.81055 3.861 6.81055 3.62988C6.81055 3.14486 6.54036 2.90234 6 2.90234ZM5.25293 10.5H6.74219V5.04102H5.25293V10.5Z" fill="#046A38" />
                        </svg>
                    </span>}
            </p>
        }
        {dataKey === "AdjustedForecast0" && <input
            type="text"
            name="AdjustedForecast0"
            value={adjustedForecast0}
            onFocus={(e)=>{
                e.stopPropagation();
            }}
            onChange={(e) => {
                e.stopPropagation();
                setAdjustedForecast0(+e?.target?.value);
                handleForecastChange({
                    newValue: e?.target?.value,
                    SKUl: rowData["SKUl"],
                    type: 0,
                    Forecast0: rowData[dataKey],
                    Forecast1: rowData["AdjustedForecast1"],
                    prevForecast0: rowData["forecastMonth0"],
                    prevForecast1: rowData["forecastMonth1"],
                    Comments: rowData["Comments"],
                })
            }}
        />}
        {dataKey === "forecast_date" && <p className="table-cell-title font-normal">{rowData[dataKey]?.slice(0, 10)}</p>}
        {dataKey === "standard_price" && <p className="table-cell-title font-normal ">${formatNumber((rowData[dataKey] || 0)?.toFixed(2))}</p>}
        {dataKey === "annualRevenue" && <p className="table-cell-title font-normal ">${formatNumber((rowData[dataKey] || 0)?.toFixed(2))}</p>}
        {dataKey === "AvgDemand_Last12Months" && <p className="table-cell-title font-normal ">{formatNumber((rowData[dataKey] || 0)?.toFixed(0))}</p>}
        {dataKey === "Alerts" && <Whisper followCursor trigger="hover" speaker={<Tooltip>{rowData[dataKey].replace(/([a-z])([A-Z])/g, "$1 $2")}</Tooltip>}>
            <p className="table-cell-title font-normal">
                {rowData[dataKey].replace(/([a-z])([A-Z])/g, "$1 $2")}
            </p>
        </Whisper>}
        {dataKey === "AvgDemand_Last8Months" && formatNumber((rowData[dataKey] || 0)?.toFixed(0))}
        {dataKey === "AvgDemand_Last4Months" && <p className="table-cell-title font-normal ">
            {formatNumber((rowData[dataKey] || 0)?.toFixed(0))}
        </p>}
        {dataKey === "AvgForecast_Last4Months" && <p className="table-cell-title font-normal">{formatNumber((rowData[dataKey] || 0)?.toFixed(0))}</p>}
        {dataKey === "CurrentMonthDemandLY" && formatNumber((rowData[dataKey] || 0)?.toFixed(0))}
        {dataKey === "forecastMonth1" && <p className="table-cell-title font-normal ">
            {formatNumber((rowData[dataKey] || 0)?.toFixed(0))}
        </p>}
        {dataKey === "isReviewed" && <ButtonToolbar className="pb-1 ">
            <ButtonGroup>
                <Button
                    onClick={(e) => {
                        e.stopPropagation()
                        handleReviewClick({
                            check: rowData[dataKey] == 0 ? 0 : 0,
                            SKUl: rowData["SKUl"],
                            Comments: rowData["Comments"],
                        });
                    }}
                    size="xs"
                    appearance="ghost"
                    className={`${rowData[dataKey] == 0 ?
                        "bg-[#BC2525] text-white" : "bg-[#949494] text-white"
                        } text-xs`}
                >
                    N
                </Button>
                <Button
                    // onClick={() => handleGraph(2)}
                    onClick={(e) => {
                        e.stopPropagation()
                        handleReviewClick({
                            check: rowData[dataKey] == 2 ? 2 : 2,
                            SKUl: rowData["SKUl"],
                            Comments: rowData["Comments"],
                        });
                    }}
                    appearance="ghost"
                    size="xs"
                    className={`${rowData[dataKey] == 2 ?
                        "bg-yellow-500 text-white" : "bg-[#949494] text-white"}
                            text-xs `}
                >
                    IP
                </Button>
                <Button
                    onClick={(e) => {
                        e.stopPropagation()
                        handleReviewClick({
                            check: rowData[dataKey] == 1 ? 1 : 1,
                            SKUl: rowData["SKUl"],
                            Comments: rowData["Comments"],
                        });
                    }}
                    appearance="ghost"
                    size="xs"
                    className={`${rowData[dataKey] == 1 ?
                        "bg-deloitteGreen text-white" : "bg-[#949494] text-white"}  
                            text-xs`}
                >
                    Y
                </Button>
            </ButtonGroup>
        </ButtonToolbar>}
        {dataKey === "AdjustedForecast1" && <input
            name="AdjustedForecast1"
            type="text"
            value={adjustedForecast1}
            onFocus={(e)=>{
                e.stopPropagation();
            }}
            onChange={(e) => {
                e.stopPropagation();
                setAdjustedForecast1(+e?.target?.value)
                handleForecastChange({
                    newValue: e?.target?.value,
                    SKUl: rowData["SKUl"],
                    type: 1,
                    Forecast0: rowData["AdjustedForecast0"],
                    Forecast1: rowData[dataKey],
                    prevForecast0: rowData["forecastMonth0"],
                    prevForecast1: rowData["forecastMonth1"],
                    Comments: rowData["Comments"],
                })
            }}
        />}
        {dataKey === "Lag1_Foreast" && formatNumber((rowData[dataKey] || 0)?.toFixed(0))}
        {dataKey === "Lag2_Foreast" && formatNumber((rowData[dataKey] || 0)?.toFixed(0))}
        {dataKey === "Last4Month_Accuracy" && <p className="table-cell-title font-normal">{((rowData[dataKey] || 0) * 100)?.toFixed(0)}%</p>}
        {dataKey === "forecastMonth0" && formatNumber((rowData[dataKey] || 0)?.toFixed(0))}
        {dataKey === "CurrentMonthOpenSalesQty" && <p className="table-cell-title font-normal">{formatNumber((rowData[dataKey] || 0)?.toFixed(0))}</p>}
        {dataKey === "Comments" && ((rowData[dataKey] || Comments) && !isFocused ? (
                <Whisper trigger="hover" placement="top" speaker={<Tooltip>{rowData[dataKey] || Comments}</Tooltip>}>
                    <textarea
                        onClick={(e) => e.stopPropagation()}
                        key={rowData[dataKey]}
                        value={Comments}
                        ref={textareaRef}
                        onFocus={handleFocus}
                        onBlur={handleBlur}
                        rows={1}
                        onChange={(e) => {
                            setComments(e?.target?.value);
                            handleForecastChange({
                                Comments: e?.target?.value,
                                SKUl: rowData["SKUl"],
                                type: 2,
                                Forecast0: rowData["AdjustedForecast0"],
                                Forecast1: rowData["AdjustedForecast1"],
                                prevForecast0: rowData["forecastMonth0"],
                                prevForecast1: rowData["forecastMonth1"],
                                newValue: 0,
                            });
                        }}
                    />
                </Whisper>
            ) : (
                <textarea
                    onClick={(e) => e.stopPropagation()}
                    key={rowData[dataKey]}
                    value={Comments}
                    ref={textareaRef}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    rows={1}
                    onChange={(e) => {
                        setComments(e?.target?.value);
                        handleForecastChange({
                            Comments: e?.target?.value,
                            SKUl: rowData["SKUl"],
                            type: 2,
                            Forecast0: rowData["AdjustedForecast0"],
                            Forecast1: rowData["AdjustedForecast1"],
                            prevForecast0: rowData["forecastMonth0"],
                            prevForecast1: rowData["forecastMonth1"],
                            newValue: 0,
                        });
                    }}
                />
            ))}
    </Cell>
};

export default CustomCell;